/**
 * Challenge card – home header, badges, and countdown.
 * Composed by challengeCard.styles.ts. Uses narrow breakpoint for smaller sizes.
 */

import type { Theme } from '../../theme/getTheme';
import { getChallengeCardHeaderLayoutStyles } from './challengeCardHeaderLayout.styles';
import { getChallengeCardHeaderTimerStyles } from './challengeCardHeaderTimer.styles';

export function getChallengeCardHeaderStyles(theme: Theme, narrow: boolean) {
  return {
    ...getChallengeCardHeaderLayoutStyles(theme, narrow),
    ...getChallengeCardHeaderTimerStyles(theme, narrow),
  };
}
